export default "__VITE_ASSET__DgEL6KSJ__"